import { request } from './request'

export const login = async (params: any) => {
    return await request('login', params)
}

export const currentUser = async () => {
    return await request('getUserInfo')
}

export const createUser = async (params: any) => {
    return await request('createUser', params)
}

export const updateUser = async (params: any) => {
    return await request('updateUser', params)
}

export const userList = async (params: any) => {
    return await request('userList', params)
}

export const switchUser = async (params: any) => {
    return await request('switchUser', params)
}

export const resetPassword = async (params: any) => {
    return await request('resetPassword', params)
}

export const updatePassword = async (params: any) => {
    return await request('updatePassword', params)
}

export const allUserList = async () => {
    return await request('allUserList')
}